import { render, staticRenderFns } from "./portDataGoodsInfo.vue?vue&type=template&id=138dbcee&scoped=true&"
import script from "./portDataGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./portDataGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./portDataGoodsInfo.vue?vue&type=style&index=0&id=138dbcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138dbcee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138dbcee')) {
      api.createRecord('138dbcee', component.options)
    } else {
      api.reload('138dbcee', component.options)
    }
    module.hot.accept("./portDataGoodsInfo.vue?vue&type=template&id=138dbcee&scoped=true&", function () {
      api.rerender('138dbcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/portDataGoodsInfo.vue"
export default component.exports